import React, {FC, HTMLProps} from 'react';

interface Props extends HTMLProps<HTMLDivElement> {
  width: string;
}

export const HSpacer: FC<Props> = props => {
  return (
    <div {...props} className={'h-full'} style={{width: props.width}}></div>
  );
};
